import { render, staticRenderFns } from "./fast.vue?vue&type=template&id=8fcc0b96&scoped=true&"
import script from "./fast.vue?vue&type=script&lang=js&"
export * from "./fast.vue?vue&type=script&lang=js&"
import style0 from "./fast.vue?vue&type=style&index=0&id=8fcc0b96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcc0b96",
  null
  
)

export default component.exports